/**
 * Ryan O'Dowd
 * 2025-06-08
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  TouchableOpacity,
  View,
} from 'react-native';
import {
  Switch as PaperSwitch,
} from 'react-native-paper';
import React from 'react';
import Text from '@components/common/Text';
import getStyles from './styles';
import hooks from '@hooks';

const Switch = (props: SwitchProps & React.ComponentProps<typeof PaperSwitch>) => {
  const styles = hooks.useStyles(getStyles);

  const ios_backgroundColor = styles.colors.primaryDark; // @TODO: does this work for android, too? (i don't think so...)
  const trackColor = { // @TODO: these look good on ios and android and light/dark modes?
    true: styles.colors.accent,
    false: styles.colors.lightGray,
  };
  // @TODO: android would look better with white thumb...why is this different from settings swtich for dark mode?

  return (
    <View style={styles.container}>
      <PaperSwitch
        value={props.isChecked}
        ios_backgroundColor={ios_backgroundColor}
        trackColor={trackColor}
        {...props}
      />
      <TouchableOpacity onPress={() => props.onValueChange(!props.isChecked)}>
        <Text style={styles.label(props.labelColor || ios_backgroundColor)}>{props.label}</Text>{/* @TODO: should this be tappable as well? */}
      </TouchableOpacity>
    </View>
  );
};

class SwitchProps {
  isChecked?: boolean;
  // @TODO: label should default to the right side of the checkbox and be white?
  // @TODO: make my own label instead of using Checkbox.Item
  // @TODO: disallow passing status (should be passing optional isChecked instead)
  label?: string;
  labelColor?: string;
};

Switch.displayName = 'Switch';
export default Switch;
